export const STATIC_PAGE_METADATA = {
  "/": {
    title: "Plutus | A portfolio built for what comes next",
    description: "Custom portfolio for you built using quality research",
    image: {
      url: "https://www.runplutus.com/provider-assets/1/og-image-sharecard.png",
      type: "image/png",
      width: 1731,
      height: 909,
      alt: "Expert research feeding into a Plutus portfolio managed in your brokerage account.",
    },
  },
  "/privacy": {
    title: "Privacy Policy | Plutus",
    description: "How Namsoft and Plutus collect, use, share, and protect personal information, and the privacy choices available to you.",
  },
  "/terms": {
    title: "Terms of Use | Plutus",
    description: "Terms governing use of the Plutus website and platform, including accounts, services, subscriptions, and user responsibilities.",
  },
  "/llms": {
    title: "Plutus \u2014 For LLMs",
    description: "Facts about Plutus: portfolio management, independent research providers, brokerage execution, fees, and how the platform works.",
  },
} as const;

export type StaticPagePath = keyof typeof STATIC_PAGE_METADATA;
export const STATIC_PAGE_PATHS = Object.keys(STATIC_PAGE_METADATA) as StaticPagePath[];

export function getStaticPagePath(pathname: string): StaticPagePath | null {
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";
  return Object.prototype.hasOwnProperty.call(STATIC_PAGE_METADATA, normalizedPath)
    ? normalizedPath as StaticPagePath
    : null;
}

export function staticPageCanonical(pagePath: StaticPagePath): string {
  return `https://www.runplutus.com${pagePath}`;
}
